/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />


module Meevo.Components.Controls {

    export interface ICheckBoxListItem {
        labelText: string;
        key: string;
        required?: boolean;
        defaultValue?: boolean;
    }

    export class CheckBoxList implements ng.IComponentController {
        items: ICheckBoxListItem[];
        form: ng.IFormController;
        model: _.Dictionary<any>;
        disabled?: boolean;
        required?: boolean;
        formInputValidationKey: string;
        valid: boolean;

        $onInit() {
            this.formInputValidationKey = this.items
                .reduce((str, row) => {

                    return str + row.key;
                }, '');

            setTimeout(() => {
               this.validate();
            });
        }

        valueChanged() {
            this.validate();
        }

        validate() {
            if (this.required) {
                this.valid = !!this.items
                    .reduce((checked, row) => {

                        return checked | this.model[row.key];
                    }, 0)

                this.form[this.formInputValidationKey].$setValidity('required', !!this.valid);
            }
        }

        $onDestroy() {
          this.form[this.formInputValidationKey].$setValidity('required', true);
        }
    }

    angular.module('meevo.components.controls')
        .component('checkboxList', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/check-box-list/check-box-list.html',
            controller: CheckBoxList,
            controllerAs: '$ctrl',
            bindings: {
                items: '<',
                model: '<',
                disabled: '<ngDisabled',
                required: '<ngRequired'
            },
            require: {
                form: '^form',
            }
        });
}
